import { makeAutoObservable } from 'mobx';

import { StockistBasketDTO } from "../DTOs/Basket/StockistBasketDTO";
import { ajaxController } from "./AjaxController";

//#region POST Request models
type AddToBasketRequest = {
  issueId: number
  quantity: number
}

type RemoveFromBasketRequest = {
  issueId: number
}

type UpdateBasketModel = {
  oldIssueId: number
  issueId: number
  quantity: number
}

//#endregion

export class BasketAjaxController {
  private _ajaxController = ajaxController;
  private _basketEndpoint = "stockistBasket"

  getBasket() {
    return this._ajaxController.get<StockistBasketDTO>(
      `${this._basketEndpoint}`,
      {},
      StockistBasketDTO
    )
  }

  addToBasket(issueId: number, quantity: number) {
    const data: AddToBasketRequest = { issueId, quantity }
    return this._ajaxController.post<AddToBasketRequest, StockistBasketDTO>(`${this._basketEndpoint}/add`, data, StockistBasketDTO)
  }

  removeFromBasket(issueId: number) {
    const data: RemoveFromBasketRequest = { issueId }
    return this._ajaxController.post<RemoveFromBasketRequest, StockistBasketDTO>(`${this._basketEndpoint}/item/remove`, data, StockistBasketDTO)
  }

  updateBasket(issueId: number, quantity: number) {
    const data: UpdateBasketModel = { oldIssueId: issueId, issueId, quantity }
    return this._ajaxController.post<RemoveFromBasketRequest, StockistBasketDTO>(`${this._basketEndpoint}/item/update`, data, StockistBasketDTO)
  }

  updateBasketAddress(newAddressId: number) {
    const data = { newAddressId }

    return this._ajaxController.post<{ newAddressId: number }, StockistBasketDTO>(`${this._basketEndpoint}/address/update`, data, StockistBasketDTO)
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const basketAjaxController = new BasketAjaxController();